import PropTypes from 'prop-types'
import { mergeOverrides } from 'baseui'
import { SDCheckboxOverrides } from './styled-components'
import { Checkbox } from 'baseui/checkbox'

const SDCheckbox = ({ label, overrides, checked, onChange, error, labelPlacement, ...rest }) => {
  const newOverrides = mergeOverrides(SDCheckboxOverrides(error || false), overrides)

  return (
    <Checkbox
      {...rest}
      checked={checked}
      overrides={newOverrides}
      onChange={e => onChange(e.target.checked)}
      labelPlacement={labelPlacement}
    >
      {label}
    </Checkbox>
  )
}

SDCheckbox.propTypes = {
  label: PropTypes.node,
  overrides: PropTypes.object,
  checked: PropTypes.any,
  onChange: PropTypes.func,
  labelPlacement: PropTypes.any,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default SDCheckbox
